import { filter, groupBy, prop, values } from 'ramda'
import { useAssetsFieldValues } from '../_load/AssetsFieldValuesLoader'

export const UNIT_REPLY_ID = 'UNIT_REPLY_ID'
export const SERVICE_DESCRIPTION_REPLY_ID = 'SERVICE_DESCRIPTION_REPLY_ID'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  return reply?.value
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const useGroupReplies = () => {
  const assets = useAssetsFieldValues()

  return (replies = []) => {
    const buildingReply = replies.find(reply => reply.question?.id === 137)
    return values(
      groupBy(
        prop('blockIndex'),
        filter(reply => reply.blockIndex !== -1, replies)
      )
    ).map(group => {
      const serviceCodeReply = findReplyByQuestionId(group, 149)
      const asset = assets.find(asset => {
        return asset?.type?.name == getReplyValue(serviceCodeReply)
      })

      const unitField = asset?.fieldValues?.find(fieldValue => fieldValue.field.id === 4)

      const unitReply = {
        question: { id: UNIT_REPLY_ID },
        value: unitField ? parseFloat(unitField?.value?.replace('R$', '').replace(',', '.')) : ''
      }
      const serviceDescriptionReply = { question: { id: SERVICE_DESCRIPTION_REPLY_ID }, value: asset?.name }

      if (buildingReply) group.push(buildingReply)
      if (unitReply) group.push(unitReply)
      if (serviceDescriptionReply) group.push(serviceDescriptionReply)

      return group
    })
  }
}
